import {
    getAllData,
    getDataWithParams,
    uploadData,
    downloadFile,
    postData

} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    input_type: null,
    file_result: null,
    fileresult_path: null,
    study_course_uajy_id: null,
    study_course_uajy_name: null,
    mata_kuliah_konversi: null,
    ID_StudentExchange: null,
    nama_mahasiswa: null,
    nama_matakuliah: null,
    jenis_semester: null,
    fase: null,
    result: null,
    grade: null,
    univ_name: null,
    status: null,
    convertion_result: null,
    convertion_grade: null,
    note: null
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "DESC",
    search: null,
    filter: null,
    semester: null
}
const initialState = () => ({
    data: {},
    msg: "Jaringan Bermasalah",
    allcourseUAJY: [],
    status: 0,
    request: {...requestInit},
    item: {...itemInit},
    stdexcStatus: [
        {
            class: "y-alert-warning",
            value: "Menunggu verifikasi prodi",
            id: 0
        },
        {
            class: "y-alert-primary2",
            value: "Pendaftaran Pertukaran Pelajar Berhasil",
            id: 1
        },
        {
            class: "y-alert-secondary",
            value: "Menunggu verifikasi Nilai prodi",
            id: 2
        },
        {
            class: "y-alert-primary",
            value: "Menunggu Verifikasi Nilai TU",
            id: 3
        },
        {
            class: "y-alert-success",
            value: "Nilai Terverifikasi",
            id: 4
        },
        {
            class: "y-alert-warning",
            value: "Menunggu persetujuan prodi",
            id: 80
        },
        {
            class: "y-alert-success",
            value: "Pengajuan Penolakan Berhasil",
            id: 81
        },
        {
            class: "y-alert-error",
            value: "Pengajuan Penolakan Ditolak",
            id: 82
        },
        {
            class: "y-alert-error",
            value: "Pendaftaran ditolak prodi",
            id: 90
        },
        {
            class: "y-alert-error",
            value: "Pendaftaran Nilai ditolak prodi",
            id: 91  
        },
        {
            class: "y-alert-error",
            value: "Pendaftaran Nilai Ditolak oleh TU",
            id: 92
        },
    ],
    chat: []
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getItem: state => state.item,
    GetStdExcStatus: state => (status) => state.stdexcStatus.find(x=>x.id==status),
    getResponse: state => state.response,
    getBlobData: state => state.blobData,
    getChat: state => state.chat || [],
    getAutoComplete: state => state.allcourseUAJY,

}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.response
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.response = {
            msg: response.msg,
            status: response.status
        }
        
    },
    SET_RESPONSE_CHAT(state, response) {
        state.msg= response.msg,
        state.status= response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    SET_CHAT(state, value) {
        state.chat = value
    },
    SET_STUDYCOURSE_UAJY(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.allcourseUAJY = response.data
    },
}


const actions = {
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    resetItem({commit}){
        commit('SET_ITEM', {...itemInit})
    },
    resetRequest({commit}){
        commit('SET_REQUEST', {...requestInit})
    },
    async getAllData({commit, state}) {
        try {
            const response = await getDataWithParams('/studentexchange-byprodi', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async getAllDataRejection({commit, state}) {
        try {
            const response = await getDataWithParams('/studentexchange-rejectionprodi', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async getAllcourseUAJY({commit }) //Get all university tanpa pagination
    {
        try {
            var response = await getAllData('/studentexchange-uajycourse');
            commit('SET_STUDYCOURSE_UAJY', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },

    //Verifikasi Pendaftaran Pertukaran Pelajar Prodi
    async verifyRegistrationProdi({commit }, {id, data}) {
        try {
            const url = `/studentexchange-byprodi/status/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async verifyRejectionProdi({commit }, {id, data}) {
        try {
            const url = `/studentexchange-byprodi/rejectionconfirm/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //Verifikasi Ujian Pertukaran Pelajar Prodi
    async verifyExamProdi({commit }, {id, data}) {
        try {
            const url = `/studentexchange-nilaiprodi/status/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //Fungsi mendapatkan data ujian prodi
    async getAllDataExam({commit, state}) {
        try {
            const response = await getDataWithParams('/studentexchange-dataUjian', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //Fungsi mendapatkan data ujian TU
    async getAllDataExamTU({commit, state}) {
        try {
            const response = await getDataWithParams('/studentexchange-getdatatu', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //Verifikasi Ujian Pertukaran Pelajar TU
    async verifyExamTU({commit }, {id, data}) {
        try {
            const url = `/studentexchange-tunilai/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //fungsi menampilkan data ujian mahasiswa
    async getDataExamTaken({commit, state}) {
        try {
            const response = await getDataWithParams('/studentexchange-examtaken', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async updateNilai({commit }, {id, data}) {
        try {
            const url = `/studentexchange-nilaiprodi/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async downloadFile({commit }, {url, type}) 
    {
        try {
            var response = await downloadFile(url);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    //Region Chat
    async getAllExamChat({commit }, id) {
        try {
            const url = `/studentexchange-chat/${id}`
            const response = await getAllData(url)
            commit('SET_RESPONSE_CHAT', response.data)
            commit('SET_CHAT', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async postExamChat({commit }, {message, id}) {
        try {
            const url = `/studentexchange-chat/${id}`
            const response = await postData(url, {message})
            commit('SET_RESPONSE_CHAT', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    }
}




export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}